// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatasts } from "../../../icons/mono/build/icon-statasts.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatastsIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatasts.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatastsIcon.displayName = 'StatastsIcon';
}

export default StatastsIcon;